export default {
  data: () => ({
    results: [],
    error: null,
    moreThanOnePage: false,
    notLastPage: true,
    sortByOptions: [
      { label: 'Relevance', optionValue: 'r' },
      { label: 'Last updated', optionValue: 'lu' },
    ],
    form: {
      sortBy: null,
      q: '',
      start: 0,
    },
  }),
  props: {
    pageSize: Number,
    multiple: Boolean,
    notLast: Boolean,
  },
  methods: {
    nextPage() {
      this.form.start += this.pageSize
      if (this.moreThanOnePage && this.notLastPage) {
        this.$http
          .post('api/v1/search', null, {
            params: {
              q: this.form.q,
              sortBy: this.form.sortBy,
              start: this.form.start,
            }
          })
          .then(res => {
            this.moreThanOnePage = res.data.moreThanOnePage
            this.notLastPage = res.data.notLastPage
            this.results = this.results.concat(res.data.results)
          })
          .catch(error => {
            this.error = error
          })
      }
    }
  },
  watch: {
    'form.sortBy': {
      handler(val, oldVal) {
        if (oldVal !== null) {
          const parameters = (new URL(window.location)).searchParams
          if (parameters.get('start')) {
            parameters.delete('start')
          }
          if (parameters.get('sortBy')) {
            parameters.delete('sortBy')
          }
          parameters.append('sortBy', val)

          const urlOrigin = window.location.origin
          const urlPathname = window.location.pathname
          const searchParams = parameters.toString()

          window.location.href = `${urlOrigin}${urlPathname}?${searchParams}`
        }
      },
    },
  },
  created() {
    const parameters = (new URL(window.location)).searchParams
    if (parameters.get('sortBy')) {
      this.form.sortBy = parameters.get('sortBy')
    } else {
      this.form.sortBy = 'r'
    }
    this.form.q = parameters.get('q')
    this.form.start = parameters.get('start') || 0
    this.moreThanOnePage = this.multiple
    this.notLastPage = this.notLast
  },
}
